import * as ActionConfigurationManager from './config.actions';

export const getDiscount = ActionConfigurationManager.GET_DISCOUNT
export const getDiscountSuccess = ActionConfigurationManager.GET_DISCOUNT_SUCCESS
export const getDiscountFailed = ActionConfigurationManager.GET_DISCOUNT_FAILED
export const fullPayFive = ActionConfigurationManager.DISCOUNT_FULL_PAY_FIVE
export const reset = ActionConfigurationManager.DISCOUNT_RESET_FORM
export const loadInitState = ActionConfigurationManager.DISCOUNT_LOAD_INIT_STATE